import { urls } from 'services/_url';
import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import { TransactionalOverview } from './sections/overview';
import { ClicksLogs } from './sections/clicks';
import { OpenLogs } from './sections/opens';
import { BounceLogs } from './sections/bounces';
import { useTransactionalService } from 'hooks/transactional';
import { useDispatch, useSelector } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { TransactionalPreview } from './sections/preview';
import { SendsLogs } from './sections/sends';
import { Button } from 'app/shared/button';
import { Spacer } from 'app/layouts/generic';
import useScreenSize from 'hooks/size';

const getNavItems = (transactional_id) => [
  {
    title: 'Overview',
    path: `/transactionals/${transactional_id}/`
  },
  {
    title: 'Details',
    path: `/transactionals/${transactional_id}/details`
  },
  {
    title: 'Delivery log',
    path: `/transactionals/${transactional_id}/deliveries`
  },
  {
    title: 'Opens log',
    path: `/transactionals/${transactional_id}/opens`
  },
  {
    title: 'Clicks log',
    path: `/transactionals/${transactional_id}/clicks`
  },
  {
    title: 'Bounce log',
    path: `/transactionals/${transactional_id}/bounces`
  }
];

export const TransactionalViewPage = () => {
  const { id } = useParams();
  const { token } = useSelector((store) => store.user_data);
  const { isMobile } = useScreenSize();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fetchTransactionalById } = useTransactionalService();

  const [transactional, setTransactional] = useState({});

  useEffect(() => {
    fetchTransactionalById(id).then(({ transactional }) => {
      setTransactional(transactional);
      dispatch(
        setPageTitle([
          { title: 'My Transactionals', path: '/transactionals' },
          { title: transactional.name, path: `/transactionals/${id}` }
        ])
      );
    });
  }, [id]);

  const handleEditAction = () => {
    if (transactional.is_advanced) {
      window.location.href = `${urls.editor}/transactionals/${transactional.id}?t=${token}`;
      return;
    }

    navigate(`/editor/transactional/${transactional.id}`);
  };

  return (
    <PageContentWrapper>
      <SlidingNav
        nav_items={getNavItems(id)}
        actions={
          !isMobile && <Button text="Edit template" icon_name="edit" onClick={handleEditAction} />
        }
      />
      {isMobile && <Spacer multiple={4} />}
      <div className="dt-content-wrapper">
        <Routes>
          <Route path="bounces" element={<BounceLogs />} />
          <Route path="deliveries" element={<SendsLogs />} />
          <Route path="clicks" element={<ClicksLogs />} />
          <Route path="details" element={<TransactionalPreview />} />
          <Route path="opens" element={<OpenLogs />} />
          <Route path="/*" element={<TransactionalOverview />} />
        </Routes>
      </div>
    </PageContentWrapper>
  );
};
